const t = {
  name: "Battery",
  dimensions: { width: 40, height: 22 },
  content: `
    <svg fill="currentColor">
    <g clip-path="url(#clip0_12_4436)">
    <path d="M38 5.45005H35V2.52216C35 1.41158 34.1 0.50293 33 0.50293H2C0.9 0.50293 0 1.41158 0 2.52216V19.4837C0 20.5943 0.9 21.5029 2 21.5029H33C34.1 21.5029 35 20.5943 35 19.4837V16.5558H38C39.1 16.5558 40 15.6472 40 14.5366V7.46928C40 6.3587 39.1 5.45005 38 5.45005ZM33 19.4837H3C2.4 19.4837 2 19.0799 2 18.4741V2.52216H32C32.6 2.52216 33 2.92601 33 3.53178V7.46928V14.5366V19.4837ZM38 14.5366H36C35.4 14.5366 35 14.1327 35 13.527V7.46928H37C37.6 7.46928 38 7.87312 38 8.47889V14.5366Z" />
    <path d="M29.5 9.9934H28V8.47898C28 7.87321 27.6 7.46936 27 7.46936C26.4 7.46936 26 7.87321 26 8.47898V9.9934H24.5C23.9 9.9934 23.5 10.3972 23.5 11.003C23.5 11.6088 23.9 12.0126 24.5 12.0126H26V13.5271C26 14.1328 26.4 14.5367 27 14.5367C27.6 14.5367 28 14.1328 28 13.5271V12.0126H29.5C30.1 12.0126 30.5 11.6088 30.5 11.003C30.5 10.3972 30.1 9.9934 29.5 9.9934Z" />
    <path d="M10.5 9.99329H5.5C4.9 9.99329 4.5 10.3971 4.5 11.0029C4.5 11.6087 4.9 12.0125 5.5 12.0125H10.5C11.1 12.0125 11.5 11.6087 11.5 11.0029C11.5 10.3971 11.1 9.99329 10.5 9.99329Z" />
    </g>
    <defs>
    <clipPath id="clip0_12_4436">
    <rect width="40" height="21" fill="currentColor" transform="translate(0 0.50293)"/>
    </clipPath>
    </defs>
    </svg>



  `
};
export {
  t as Battery
};
